// Our export endpoints answer it when the file is queued; the bell announces it once it is ready.
const HTTP_STATUS_FILE_IN_PREPARATION = 210;

const handleResponseNotifications = async ({ response, responseJson }) => {
  const defaults = response.ok ? {
    level: 'success',
  } : {
    level: 'error',
    message: global_i18n('ajax_fail_notification'),
    duration: 'none',
  };

  const {
    heading = defaults.heading,
    message,
    notification,
    level = defaults.level,
    content_type = defaults.content_type, // TODO: handle different content types (e.g. text, HTML)
    duration = defaults.duration,
  } = responseJson || {};
  const invalidParams = responseJson?.['invalid-params']?.map(param => param.reason).join(', ');
  const _message = message || notification || invalidParams || defaults.message
  if (_message) {
    window.notification(_message, { heading, duration, type: level });
  }
  if (response.status === HTTP_STATUS_FILE_IN_PREPARATION) {
    window.MentionsHandler?.refreshNotificationsUntilNewArrives();
  }
};
  
export default handleResponseNotifications;
  